import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/community-portal/community-portal/src/modules/layouts/mdx_layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Crafting Technical Content`}</h1>
    <p>{`This section is not about writing - the Writing Guide in our Learn section will teach you everything
you need to know about our style, tone, and other content tricks. This section is all about how to
add automagic, ready-made React components to your files so that they really pop. The basics:
buttons, Calls to Action (CTAs), images, headers etc. can be found inside the `}<a parentName="p" {...{
        "href": "/resources/technical-content/palette-recipes/"
      }}>{`pallete`}</a>{`. Gradually with time contributors progress to passing your own props to
some of the more advanced components this site offers, all while remaining in a familiar markdown file. `}</p>
    <p>{`All of this is possible thanks the framework this site uses: `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/"
      }}>{`Gatsby.`}</a>{` We're
able to leverage it's unique and modern features to build an incredibly fast, slick and easy-to-use
structure that many different people, with very different skills, and at many levels of technical
understanding can readily use, adapt, contribute to and extend.`}</p>
    <p>{`Writing markdown which renders responsive React components is a superpower. We hope you'll use it responsibly.`}</p>
    <h2>{`Basics`}</h2>
    <p>{`Not everyone wants to be a hardcore developer. Writing truly engaging content,
that both delights and educates people, is an underrated talent and you
shouldn't be required to learn all the intricacies of modern web frameworks
just to produce awesome pages. In the past, the best you could have done
would be to write content in your editor of choice, export it into markdown
and then hope that some developer somewhere can incorporate it and add the styles,
buttons, images and other visual features which are required to make content transformational,
rather than just more boring information.`}</p>
    <p>{`This site changes all that.`}</p>
    <h2>{`What is Mdx anyway?`}</h2>
    <p>{`In short: it's your normal markdown - `}<inlineCode parentName="p">{`md`}</inlineCode>{` - with an added little `}<inlineCode parentName="p">{`x`}</inlineCode>{` factor.
In practice, the `}<inlineCode parentName="p">{`x`}</inlineCode>{` means that we can `}<inlineCode parentName="p">{`extend`}</inlineCode>{` the capabilities of markdown
and, in fact, create entire React components directly in our content files. If you
don't know what a React component is, or why you would want to have them in your
content files, don't stress! This section is all about showing you how this is
actually a writing superpower, and how you can put it to best use when contributing.`}</p>
    <p>{`You might have used a markdown cheatsheet
before to figure out how to handle headings, links, images, and other basic necessities.
The beauty of `}<inlineCode parentName="p">{`mdx`}</inlineCode>{` is that all that stuff still works exactly the same. You'll still be
writing what appears - for the most part - to be normal markdown. It's just that
we can now do so much more...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      